import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./LogoMark";

const LangToggle = ({ lang, setLang, id = "" }) => (
  <div className="flex border border-current/30 text-xs font-mono" data-testid={`language-toggle${id}`}>
    {["en", "fr"].map((l) => (
      <button
        key={l}
        data-testid={`language-toggle-${l}${id}`}
        onClick={() => setLang(l)}
        className={`px-2.5 py-1.5 uppercase tracking-widest transition-colors duration-300 ${
          lang === l ? "bg-[#0F2137] text-white" : "text-[#0F2137] hover:bg-slate-100"
        }`}
      >
        {l}
      </button>
    ))}
  </div>
);

export const Header = ({ t, lang, setLang, go }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const links = [["about", t.nav.about], ["practice", t.nav.practice], ["contact", t.nav.contact]];
  const nav = (id) => { setOpen(false); go(id); };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 border-b ${
        scrolled ? "bg-white/95 backdrop-blur border-slate-200 py-3" : "bg-white border-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 lg:px-10">
        <button data-testid="nav-link-hero" onClick={() => nav("hero")} className="flex items-center gap-3 text-left">
          <LogoMark className="h-11 w-11" />
          <span className="leading-tight">
            <span className="block font-serif text-lg font-semibold text-[#0F2137]">CM Ocenia Trust</span>
            <span className="block font-mono text-[10.5px] uppercase tracking-[0.2em] text-slate-500">Grande Comore</span>
          </span>
        </button>
        <nav className="hidden items-center gap-9 md:flex">
          {links.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => nav(id)} className="nav-link text-sm text-slate-700 hover:text-[#0F2137]">
              {label}
            </button>
          ))}
          <LangToggle lang={lang} setLang={setLang} />
        </nav>
        <button data-testid="mobile-menu-toggle" className="md:hidden text-[#0F2137]" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-slate-200 bg-white px-6 py-6 space-y-5">
          {links.map(([id, label]) => (
            <button key={id} data-testid={`mobile-nav-link-${id}`} onClick={() => nav(id)} className="block font-serif text-2xl text-[#0F2137]">
              {label}
            </button>
          ))}
          <LangToggle lang={lang} setLang={setLang} id="-mobile" />
        </div>
      )}
    </header>
  );
};
